import React from "react";
import Profile from "./Profile";
import withTabs from "../../../../components/withTabs";

export default withTabs(Profile);
